import { loop, Cmd } from 'redux-loop';
import { parseResponse } from 'utils';
import config from 'config';

// We need this in the backend for the link to come back here
const app = 'mobile';

const requestInitiate = async (provider, payload) => {
  const response = await fetch(`${config.AUTH_URL}/sso/${provider}/initiate?app=${app}`, {
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
    headers: {
      'Content-type': 'application/json'
    },
    body: JSON.stringify(payload),
  })

  const result = await parseResponse(response);
  return result;
};

const initiateSuccess = (response) => ({
  ...response,
  type: 'INITIATE_SSO_COMPLETE',
});

const initiateFail = ({ code, text }) => ({
  type: 'INITIATE_SSO_FAILED',
  code,
  text,
});

const initialState = {
  done: false,
  loading: false,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch(action.type) {
    case 'INITIATE_SSO_REQUEST':
      return loop({ done: false, loading: true, error: null, },
                Cmd.run(requestInitiate, {
                  successActionCreator: initiateSuccess,
                  failActionCreator: initiateFail,
                  args: [ action.provider, action.payload ],
                }));
    case 'INITIATE_SSO_COMPLETE':
      return { done: true, loading: false, error: null };
    case 'INITIATE_SSO_FAILED':
      return { done: false, loading: false, error: action.code };
    case 'RESET_AUTH_ERROR':
      return {
        ...state,
        error: null,
      };
    case 'RESET_AUTH':
    case 'LOGOUT_REQUEST':
      return initialState; // The 'auth' reducer will do the rest
    default:
      return state;
  }
};

export {
  reducer as sso,
};
